import React from 'react';
import WrapperSection from '../../components/global/WrapperSection';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import LevelsTable from '../../components/levels/LevelsTable';

const LevelsArchive = () => (
    <WrapperSection>
        <GlobalBreadcrumbs />
        <LevelsTable isArchive />
    </WrapperSection>
);

export default LevelsArchive;
